import React from 'react';
import { Icon } from '../icon';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Modal Title Component
 * @param children {string}
 * @param className {string} clsx
 * @param iconName {IconName} IconName for icon title
 * @param iconColor {IconColor} IconColor for icon title
 */
const ModalTitle = ({ children, className, iconColor, iconName }) => {
    const { styled } = useTrilogyContext();
    return (React.createElement("div", { className: hashClass(styled, clsx('modal-title', className)) }, iconName ? React.createElement(Icon, { color: iconColor, size: 'large', name: iconName, content: children, position: 'up' }) : children));
};
export default ModalTitle;
//# sourceMappingURL=ModalTitle.js.map